import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d9c5bc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { ref } from "vue";
import routeHash from '@/constant/router_hash'
import { useRouter } from 'vue-router'
import Mitt from "@/utils/mitt";

const __default__ = {
  name: 'DropdownBar'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ["options"],
  setup(__props) {

const props = __props;

const visible = ref(false)
const isOnSheet = ref(false) 

const bar = ref(null)
const leftDistance = ref(0)
const router = useRouter()

const onJumpTo = (hash: string) => {
  if (hash.startsWith("/")) {
    router.push({ path: hash })
    return
  }
  setTimeout(() => Mitt.emit(hash), 0)
  switch(hash) {
    case routeHash.AIR_TO_LIQUID_COOLING:
    case routeHash.SYSTEMIC_LIQUID_COOLING:
    case routeHash.RDHX_AIR_COOLED:
      router.push({ path: "/solution" })
      return;
    case routeHash.IDC_LIQUID_COOLING:
    case routeHash.AIGC_INFRASTRUCTURE:
      router.push({ path: "/service" })
      return;
    case routeHash.L2A_PRODUCT:
    case routeHash.L2L_PRODUCT:
    case routeHash.RDHx_PRODUCT:
    case routeHash.OTHERS_PRODUCT:
      router.push({ path: "/product"})
      return;
    case routeHash.CONTACT_US:
      router.push({ path: "/company" })
      return;
    default:
      router.push({ path: hash })
      return
  }
}

const checkLeave = () => {
  setTimeout(() => {
    if (!isOnSheet.value) {
      visible.value = false
    }
  }, 100)
}

const onHover = () => {
    if(bar.value) {
        const barRect = (bar.value as HTMLElement).getBoundingClientRect();
        const left = barRect.left;  
        leftDistance.value = left
    }
    if(props.options) {
        visible.value = true
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "dropdown_bar",
    onMouseenter: onHover,
    onMouseleave: checkLeave,
    ref_key: "bar",
    ref: bar
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _withDirectives(_createElementVNode("div", {
      class: "option_sheet",
      style: _normalizeStyle({'left': leftDistance.value + 'px'}),
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (isOnSheet.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isOnSheet.value = false))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "option",
          key: option.title,
          onClick: _withModifiers(($event: any) => (onJumpTo(option.path)), ["stop"])
        }, [
          _createElementVNode("span", null, _toDisplayString(option.title), 1)
        ], 8, _hoisted_1))
      }), 128))
    ], 36), [
      [_vShow, visible.value]
    ])
  ], 544))
}
}

})